import { isString } from "@suse-o11y/is-string";
import { z } from "zod";

import type { DashboardVariableValue } from "./_dashboard-variable";

const valueSchema = z.string().trim().catch("");

export const dashboardTextVariableSchema = z
	.object({
		value: valueSchema,
		constant: z.boolean().optional().catch(false),
	})
	.catch({
		value: "",
	});

export type DashboardTextVariableValue = z.infer<typeof valueSchema>;
export type DashboardTextVariable = z.infer<typeof dashboardTextVariableSchema>;

export function updateTextVariableValue(
	value: DashboardVariableValue,
	variable: DashboardTextVariable,
): DashboardTextVariable {
	if (value == null) {
		return variable;
	}

	if (isString(value)) {
		return { ...variable, value };
	}

	if (value.type === "Value") {
		return { ...variable, value: value.value };
	}

	if (value.type === "Values") {
		return { ...variable, value: value.values.at(0) ?? "" };
	}

	return { ...variable, value: "" };
}
